import { Hotel } from '../../api/model/hotel/hotel.model';
import { Component, OnInit, Input } from '@angular/core';
// import { Reservation } from '../../api/model/reservation/reservation.model';

@Component({
    selector: 'stay-mgmt-brand-logo',
    templateUrl: './brand-logo.component.html',
    styleUrls: ['./brand-logo.component.scss']
})
export class BrandLogoComponent implements OnInit {

    @Input() hotel: Hotel;
    constructor() { }
    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/brand-logo/brand-logo.component.ts